(function($){

	$(document).ready(function(){

		$(document).on('click','#copyrightModal .btn-accept-terms',function(e){
			e.preventDefault();
			Cookies.set('copyright_accepted', 1);
			window.open($(this).attr('href'));
			$('#copyrightModal').modal('hide');
		});

		$('#copyrightModal').on('show.bs.modal', function (e) {
			Fancybox.close();
	        var relatedTarget_href = $(e.relatedTarget).attr('href');
	        $('#copyrightModal').find('.btn-accept-terms').attr('href', relatedTarget_href);
	    });


	    $('#copyrightModal').on('hidden.bs.modal', function (e) {
	       $('body').removeClass('copyright-active'); 
	    });

	});
	
})(jQuery);